/*
  Project: Schimmelpfennig Becke
  Author: Tobias Lorenz
 */
import greet from './modules/greeting';
import schimmelpfennigBecke from './modules/schimmelpfennig-becke';
import '../../../../../../node_modules/foundation-sites/dist/js/foundation';

const $ = require('jquery');

$(document).foundation();

greet('World');
schimmelpfennigBecke();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/schimmelpfennig-becke-chisel/src/scripts/app.js